import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { ButtonBase } from '@/components/ui/Button/ButtonBase';
const colors = {
    blue: {
        bg: 'bg-turquoise-blue-100 hover:bg-turquoise-blue-200 focus:bg-turquoise-blue-200 active:bg-turquoise-blue-300',
        border: 'border-turquoise-blue-200 hover:border-turquoise-blue-200 focus:border-turquoise-blue-200 active:border-turquoise-blue-300',
    },
    gray: {
        bg: 'bg-gray-50 hover:bg-gray-75 focus:bg-gray-75 active:bg-gray-300',
        border: 'border-gray-300 hover:border-gray-300 focus:border-gray-300 active:border-gray-300',
    },
    navy: {
        bg: 'bg-navy-100 hover:bg-navy-200 focus:bg-navy-200 active:border-navy-300',
        border: 'border-navy-200 hover:border-navy-200 focus:border-navy-200 active:border-navy-300',
    },
    none: {
        bg: '',
        border: '',
    },
    orange: {
        bg: 'bg-orange-100 hover:bg-orange-200 focus:bg-orange-200 active:bg-orange-300',
        border: 'border-orange-200 hover:border-orange-200 focus:border-orange-200 active:border-orange-300',
    },
};
const textColors = {
    blue: 'white',
    gray: 'base',
    navy: 'white',
    none: 'base',
    orange: 'white',
};
/**
 * ボタンデザインが必要ない場合：
 * color={'none'}
 * isBordered={false}
 * size={'fluid'}
 */
/**
 * 共通：ボタンコンポーネント
 * NOTE: デザインシステムのルールに基づいて値を設定をしています
 * WARNING: 設定値の変更, 追加をする場合は、デザインデータの更新必須（none 等は例外）
 * @param props
 * @constructor
 */
export const Button = (props) => {
    const { children, className = '', color, disabled, isBordered, isFull, isFullRounded = false, onClick, size, textClassName, type, value, } = props;
    const shadow = !disabled
        ? 'drop-shadow-sm active:drop-shadow-none'
        : 'drop-shadow-none';
    const disabledStyle = disabled
        ? 'opacity-50 hover:cursor-default pointer-events-none'
        : '';
    return (_jsx(ButtonBase, Object.assign({ className: clsx(colors[color].bg, colors[color].border, shadow, disabledStyle, isFullRounded && '!rounded-full', className), disabled: disabled, isBordered: isBordered, isFull: isFull, onClick: onClick, size: size, textClassName: textClassName, textColor: textColors[color], type: type, value: value }, { children: children })));
};
export const buttonColors = colors;
export const buttonTextColors = textColors;
